export const de = {
  appTitle: 'HACK THE PLANET',
  appSubtitle: 'DEFEND THE SYSTEM',
  tagline: 'Angriffstechniken verstehen. Systeme schützen.',
  nav: {
    home: 'Home',
    explore: 'Atlas / Attack Map',
    status: 'Status',
    chains: 'Attack Chains',
    tools: 'Tools-DB',
    search: 'Suche',
    categories: 'Kategorien',
  },
  actions: {
    openAtlas: 'Atlas öffnen',
    searchPlaceholder: 'Techniken durchsuchen…',
    attack: 'ATTACK',
    defense: 'DEFENSE',
    filters: 'Filter',
    clearFilters: 'Filter zurücksetzen',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    reset: 'Zurücksetzen',
    fitWidth: 'Breite einpassen',
    fitScreen: 'Bild einpassen',
    fit100: '100 %',
    fullscreen: 'Vollbild',
    expandExplainatory: 'Explainatory ausklappen',
    collapseExplainatory: 'Explainatory einklappen',
    language: 'Sprache',
    back: 'Zurück',
    menu: 'Menü',
  },
  technique: {
    related: 'Verwandte Techniken',
    detection: 'Erkennung',
    defense: 'Schutzmaßnahmen',
    sources: 'Quellen',
    facts: 'Faktenübersicht',
    short: 'Kurz erklärt',
    variants: 'Varianten',
    flow: 'Typischer Ablauf',
    toc: 'Inhalt',
    tools: 'Werkzeuge',
    toolsKali: 'Kali',
    toolsCommon: 'Gängig',
    toolsDefensive: 'Defense',
    toolsEmpty: 'Keine Werkzeuge für diesen Eintrag.',
    toolsLabNote: 'Anwendungsbeispiele gelten nur für autorisierte Labs und eigene Testumgebungen.',
    notFound: 'Nicht gefunden',
    notFoundBody: 'Technik "{slug}" existiert nicht.',
    backToAtlas: 'Zurück zum Atlas',
    subcategory: 'Unterkategorie',
    attackSurface: 'Angriffsoberfläche',
    difficulty: 'Schwierigkeit',
    risk: 'Risiko',
    status: 'Status',
    readerMode: 'Reader-Modus',
    reviewMode: 'Review-Modus',
    noImage: 'Kein Bild verfügbar',
    imageLoadError: 'Bild konnte nicht geladen werden',
  },
  status: {
    title: 'Content-Status',
    needsReview: 'Needs Review',
    draft: 'Draft',
    generated: 'Generated',
    complete: 'Complete',
    review: 'Review',
    progress: 'Content Progress',
    elaborated: 'ausgearbeitet',
    final: 'final',
    total: 'Gesamt',
    elaboratedLabel: 'Ausgearbeitet',
    finalLabel: 'Final',
    missingImage: 'Fehlendes Bild',
    missingDefense: 'Fehlende Defense',
    missingDetection: 'Fehlende Detection',
    missingSources: 'Fehlende Quellen',
    missingMetadata: 'Fehlende Metadaten',
    uncategorized: 'Uncategorized',
    brokenRelated: 'Broken Related',
    categories: 'Kategorien',
    entries: 'Einträge',
    emptyHidden: '(leer – in Nav ausgeblendet)',
    imagesDe: 'Deutsche Bilder',
    imagesEn: 'Englische Bilder',
    missingEnImages: 'Fehlende EN-Bilder',
    missingMethods: 'Fehlende Atlas-Methoden',
    coverageTitle: 'Atlas-Abdeckung & Bilder',
    missingEnTitle: 'Techniken mit DE-Bild ohne EN-Bild',
    missingMethodsTitle: 'Fehlende Atlas-Methoden (noch nicht im Atlas)',
    missingEnContent: 'Fehlender EN-Inhalt',
    missingEnBriefsTitle: "EN-Techniken mit leerem In brief",
    missingEnBriefs: "Fehlende EN-Kurztexte",
    missingMethodsHint: "Kandidaten-Techniken noch nicht im Atlas",
    atlasTechniques: "Techniken im Atlas (DE)",
  },
  chains: {
    title: 'Attack Chains',
    intro: 'Mehrstufige Angriffspfade aus dem Atlas – von Initialzugriff über laterale Bewegung bis zur Exfiltration. Jede Kette verbindet vorhandene Techniken zu einem nachvollziehbaren Ablauf, gruppiert nach Ziel.',
    empty: 'Aktuell sind keine Angriffsketten hinterlegt.',
    steps: 'Schritte',
    groupedBy: 'Gruppiert nach Angriffsziel',
    oneChain: 'Kette',
    nChains: 'Ketten',
    allChains: 'Alle Attack Chains ansehen',
    moreInGroup: 'weitere in dieser Gruppe',
    unknownGoal: 'Weitere Ketten',
    goals: {
      'initial-access': 'Initialzugriff / Credential Theft',
      'lateral-movement': 'Laterale Bewegung / Rechteausweitung',
      'web-compromise': 'Web-App-Kompromittierung',
      'cloud-container': 'Cloud / Container',
      'wireless-network': 'Wireless / Netzwerk',
      'physical-social': 'Physisch / Social Engineering',
      'ai-llm': 'KI / LLM',
      'data-exfil': 'Datenexfiltration',
      other: 'Weitere Ketten',
    },
  },
  tools: {
    title: 'Tools-DB',
    intro: 'Werkzeug-Datenbank zum Atlas: Art beschreibt den Fachbereich. Jede Karte zeigt eine Primärklasse und kann zusätzliche Einsatzklassen tragen. Kali ist ein separat filterbarer Tag für Tools aus dem offiziellen Kali-Repository. Nur für autorisierte Übungen.',
    searchPlaceholder: 'Tools suchen…',
    filterCategory: 'Kategorie',
    filterKind: 'Art',
    filterSource: 'Herkunft',
    filterClass: 'Einsatzklassen',
    filterTag: 'Tag',
    allCategories: 'Alle Kategorien',
    allKinds: 'Alle Arten',
    allSources: 'Alle Herkünfte',
    allClasses: 'Alle Einsatzklassen',
    allTags: 'Alle Tags',
    results: 'Treffer',
    empty: 'Keine Tools für diese Filter.',
    notFound: 'Tool nicht gefunden.',
    backToHub: 'Zur Tools-DB',
    officialDocs: 'Offizielle Dokumentation',
    useCases: 'Anwendungsfälle',
    readme: 'Überblick & Nutzung',
    aliases: 'Aliase',
    relatedTechniques: 'Verwandte Techniken',
    noRelated: 'Keine verknüpften Techniken.',
    statTools: 'Tools',
    classes: {
      attack: 'Angriff',
      analysis: 'Analyse',
      monitoring: 'Monitoring',
      defense: 'Schutz',
      utility: 'Utility',
    },
    arts: {
      'information-gathering': 'Informationsbeschaffung',
      'vulnerability-analysis': 'Schwachstellenanalyse',
      'web-application': 'Web',
      'database-assessment': 'Datenbanken',
      'password-attacks': 'Passwort / Cracker',
      wireless: 'Wireless',
      'reverse-engineering': 'Reverse Engineering',
      exploitation: 'Exploitation',
      'sniffing-spoofing': 'Sniffing / Spoofing',
      'post-exploitation': 'Post-Exploitation',
      forensics: 'Forensik',
      reporting: 'Reporting',
      'social-engineering': 'Social Engineering',
      hardware: 'Hardware / RFID',
      defensive: 'Defense',
      utilities: 'Utilities',
    },
    chips: {
      'information-gathering': 'Recon',
      'vulnerability-analysis': 'Vuln',
      'web-application': 'Web',
      'database-assessment': 'Database',
      'password-attacks': 'Cracker',
      wireless: 'Wifi',
      'reverse-engineering': 'RE',
      exploitation: 'Exploitation',
      'sniffing-spoofing': 'Sniffing',
      'post-exploitation': 'Post-Ex',
      forensics: 'Forensics',
      reporting: 'Reporting',
      'social-engineering': 'SE',
      hardware: 'Hardware',
      defensive: 'Defense',
      utilities: 'Utilities',
    },
  },
  promo: {
    hackerCity: {
      kicker: 'Kooperativ',
      title: 'Hacker City — Kooperativer Hacking-Simulator',
      slogan: 'Red. Blue. Kein Zuschauer-Modus.',
      cta: 'Zur City',
    },
  },
  empty: 'Keine Einträge gefunden.',
  indexView: 'Index',
  mapView: 'Attack Map',
  difficulties: {
    beginner: 'Einsteiger',
    intermediate: 'Fortgeschritten',
    advanced: 'Anspruchsvoll',
    expert: 'Experte',
  },
  severities: {
    low: 'Niedrig',
    medium: 'Mittel',
    high: 'Hoch',
    critical: 'Kritisch',
  },
} as const

export type Strings = typeof de
export const strings = de
